import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { setIsModalHide, setIsModalShowed } from '@yme/modals/actions';
import { MODALS } from '@yme/modals/constants';
import { getCommonLabels, getPDPLinks } from '@yme/selectors/common';
import { selectProductVariantsByColor } from '@yme/selectors/helpers';
import { getItemImage } from '@yme/utils/common';
import { getPdpLinkByCategory, getProductURL } from '@yme/utils/product';
import { ProductPartWrapper } from '../ProductPartWrapper';
import { ProductPartContent } from './ProductPartContent';
import { getRequiredProductVariantBySku } from './helpers';
export function RequiredProductPart({ item, labels, rootLanguage, isInAuthor, isChecked, addRequiredProduct, removeRequiredProduct, checkRequiredProductAdded, isRightToLeft, className, privacyConsentsModel, }) {
    const [variantSku, setVariantSku] = useState('');
    const pdpLinks = useSelector(getPDPLinks);
    const commonLabels = useSelector(getCommonLabels);
    const [isProductAdded, setIsProductAdded] = useState(false);
    const dispatch = useDispatch();
    const { isInfiniteDesktopView } = useWindowSize();
    const { variants, name, slug, categories, id } = item;
    const { attributes, images, prices, stock, sku } = getRequiredProductVariantBySku(variants, variantSku);
    const productColorVariants = selectProductVariantsByColor({
        variantsData: item.variants,
    });
    const itemImage = getItemImage(images);
    const [price] = prices;
    const pdpPath = getPdpLinkByCategory(pdpLinks, categories);
    const itemUrl = getProductURL({
        path: pdpPath,
        isInAuthor,
        slug,
    });
    const isOutOfStock = stock === 0;
    const isProductHasOneVariant = Boolean(productColorVariants.length === 1);
    useEffect(() => {
        if (price && !isOutOfStock) {
            if (!isProductAdded && isChecked) {
                setIsProductAdded(true);
                checkRequiredProductAdded(id, true);
                addRequiredProduct({
                    id,
                    sku,
                    name,
                    price,
                    productUrl: itemUrl,
                });
            }
            if (!isChecked) {
                setIsProductAdded(false);
                checkRequiredProductAdded(id, false);
                removeRequiredProduct(id);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isChecked]);
    useEffect(() => () => {
        dispatch(setIsModalHide());
    }, [dispatch]);
    const requiredPartVariantCallback = (currentSku, currentPrice) => {
        setVariantSku(currentSku);
        addRequiredProduct({
            id,
            name,
            sku: currentSku,
            price: currentPrice,
            productUrl: itemUrl,
        });
        checkRequiredProductAdded(id, true);
        setIsProductAdded(true);
    };
    const openRequiredPartVariantModal = () => {
        dispatch(setIsModalShowed({
            type: MODALS.REQUIRED_PART_VARIANT_MODAL,
            data: {
                primaryButtonContent: commonLabels?.common_confirm_button,
                secondaryButtonContent: commonLabels?.common_cancel_button,
                labels,
                item,
                isInAuthor,
                pdpPath,
                callback: requiredPartVariantCallback,
                currentVariant: getRequiredProductVariantBySku(variants, variantSku),
            },
        }));
    };
    const onClickHandler = () => {
        if (!isProductAdded && !isProductHasOneVariant) {
            openRequiredPartVariantModal();
        }
        else if (!isProductAdded && isProductHasOneVariant) {
            addRequiredProduct({
                id,
                sku,
                name,
                price,
                productUrl: itemUrl,
            });
            checkRequiredProductAdded(id, true);
            setIsProductAdded(true);
        }
        else {
            removeRequiredProduct(id);
            checkRequiredProductAdded(id, false);
            setIsProductAdded(false);
        }
    };
    return (React.createElement(ProductPartWrapper, { isRightToLeft: isRightToLeft, isRequiredPartItem: true, className: className, isImageShowed: false },
        React.createElement(ProductPartContent, { name: name, sku: sku, itemUrl: itemUrl, stock: stock, rootLanguage: rootLanguage, isRightToLeft: isRightToLeft, isOutOfStock: isOutOfStock, price: price, isProductHasOneVariant: isProductHasOneVariant, labels: labels, itemImage: itemImage, imageWrapperWidth: isInfiniteDesktopView ? '60px' : '48px', isProductAdded: isProductAdded, isRequiredPartItem: true, attributes: attributes, onClickHandler: onClickHandler, openRequiredPartVariantModal: openRequiredPartVariantModal, privacyConsentsModel: privacyConsentsModel })));
}
